<div class="dot dot--first"></div>
<div class="dot dot--second"></div>
<div class="dot"></div>
